import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ICrmResource } from './crm.types';
import { v4 as uuidv4 } from 'uuid';

@Injectable({
  providedIn: 'root',
})
export class CrmResource implements ICrmResource {
  private analyticsId: string | null = null;

  constructor(private http: HttpClient) {}

  setAnalyticsId(id: string) {
    this.analyticsId = id;
  }

  generateAnalyticsId() {
    this.analyticsId = uuidv4();
  }

  getAnalyticsId() {
    if (!this.analyticsId) {
      this.generateAnalyticsId();
    }

    return this.analyticsId!;
  }
}
